<template>
  <div class="login-container">
    <div class="login-left">
      <el-image class="login-com" :src="require('@/assets/login-com-bg.svg')" fit="contain" />
      <el-image class="login-weChatAccount" :src="require('@/assets/img/shipping.png')" />
      <p>欢迎使用发货助手！</p>
    </div>
    <div class="login-right">
      <el-image class="login-logo" :src="require('@/assets/img/icon_ar.png')" fit="contain" />
      <el-tabs v-model="activeName" stretch>
        <el-tab-pane name="first">
          <span slot="label"><i class="el-icon-full-screen"></i> 微信扫码登录</span>
          <div class="tab-box">
            <div id="weixinQr" class="weixinQr"></div>
            <div class="js_wx_default_tip">
              <p>请使用微信扫描二维码登录</p>
              <p>“发货助手”</p>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="second">
          <span slot="label"><i class="el-icon-edit"></i> 账户密码登录</span>
          <div class="tab-box">
            <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" label-position="left">
              <template v-if="mode">
                <el-form-item prop="username" class="login-item">
                  <el-input v-model="loginForm.username" auto-complete="new-password" placeholder="请输入用户名或手机号" size="large">
                    <template slot="prepend"><i class="el-icon-user" /></template>
                  </el-input>
                </el-form-item>
                <el-form-item prop="password" class="login-item">
                  <el-input v-model="loginForm.password" show-password auto-complete="on" placeholder="请输入密码" @keyup.enter.native="handleLogin" size="large">
                    <template slot="prepend"><i class="el-icon-lock" /></template>
                  </el-input>
                </el-form-item>
                <el-button :loading="loading" type="primary" size="large" class="login-button" @click.native.prevent="handleLogin">{{wexinSacn?'登录并绑定微信':'登录'}}</el-button>
                <div>
                  <el-button type="text" size="large" class="login-button forget" @click="changMode">忘记密码?</el-button>
                </div>
              </template>
              <template v-if="!mode">
                <el-form-item prop="telephone" class="login-item">
                  <el-input v-model="loginForm.telephone" auto-complete="new-password" placeholder="请输入手机号" size="large">
                    <template slot="prepend"><i class="el-icon-phone" /></template>
                  </el-input>
                </el-form-item>
                <el-form-item prop="verification" class="login-item" size="large">
                  <el-input v-model="loginForm.verification" auto-complete="new-password" placeholder="请输入验证码" size="large" class="verify">
                    <template slot="prepend"><i class="el-icon-s-opportunity" /></template>
                  </el-input>
                  <el-button type="info" :disabled="!!counttime" @click="getVCode" class="sendCode">{{counttime?counttime+'s':'发送验证码'}}</el-button>
                </el-form-item>
                <el-form-item prop="resetpwd" class="login-item">
                  <el-input v-model="loginForm.resetpwd" show-password auto-complete="on" placeholder="请输入密码" size="large">
                    <template slot="prepend"><i class="el-icon-lock" /></template>
                  </el-input>
                </el-form-item>
                <el-form-item prop="checkresetpwd" class="login-item">
                  <el-input v-model="loginForm.checkresetpwd" show-password auto-complete="on" placeholder="请确认密码" size="large">
                    <template slot="prepend"><i class="el-icon-lock" /></template>
                  </el-input>
                </el-form-item>
                <el-button :loading="loading" type="primary" size="large" class="login-button" @click.native.prevent="resetPassword">重置密码</el-button>
                <div>
                  <el-button type="text" size="large" class="login-button forget" @click="changMode">返回登录</el-button>
                </div>
              </template>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <p v-if="mode && activeName =='second'" class="tip">非手机注册的用户，忘记密码需向服务商或单位管理员索取</p>
  </div>
</template>

<script>
import Vue from 'vue'
import { getCode } from '@/utils/url'
const redirecturi = process.env.VUE_APP_REDIRECTURI
const wxappid = process.env.VUE_APP_WXAPPID

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value.length) {
        callback(new Error('用户名或手机号不能为空'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 3) {
        callback(new Error('密码不能小于3位'))
      } else {
        callback()
      }
    }
    const checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|7|8|9][0-9]{9}$/
      if (!value) {
        return callback(new Error('电话号码不能为空'))
      }
      if (!Number.isInteger(+value)) {
        callback(new Error('请输入数字值'))
      } else {
        if (phoneReg.test(value)) {
          callback()
        } else {
          callback(new Error('电话号码格式不正确'))
        }
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.loginForm.checkresetpwd !== '') {
          this.$refs.loginForm.validateField('checkresetpwd')
        }
        callback()
      }
    }
    var checkValidatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.loginForm.resetpwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      activeName: 'first',
      loginForm: {
        username: '',
        password: '',
        telephone: '',
        verification: '',
        resetpwd: '',
        checkresetpwd: ''
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        telephone: [{ required: true, trigger: 'blur', validator: checkPhone }],
        verification: [{ required: true, trigger: 'blur', message: '请输入验证码' }],
        resetpwd: [{ required: true, trigger: 'blur', validator: validatePass }],
        checkresetpwd: [{ required: true, trigger: 'blur', validator: checkValidatePass }]
      },
      mode: true,
      counttime: 0,
      wexinSacn: ''
    }
  },
  created() {
    this.scanlogin()
  },
  mounted() {
    // 拉取微信扫码二维码
    const s = document.createElement('script')
    s.type = 'text/javascript'
    s.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
    const wxElement = document.body.appendChild(s)
    wxElement.onload = function () {
      let laodvxscan = () =>
        new WxLogin({
          self_redirect: true,
          id: 'weixinQr', // 需要显示的容器id
          appid: wxappid, // 公众号appid wx*******
          scope: 'snsapi_login', // 网页默认即可
          redirect_uri: encodeURIComponent('http://ffs.shippingassistant.cn/csrAuth.html'), // 授权成功后回调的url
          state: redirecturi, // 可设置为简单的随机数加session用来校验
          style: 'black', // 提供"black"、"white"可选。二维码的样式
          href: '' // 外部css文件url，需要https
        })
      laodvxscan()
      setInterval(() => {
        // 每一分钟刷新一次二维码
        laodvxscan()
      }, 60 * 1000)
    }
  },
  methods: {
    // 扫码登录
    async scanlogin() {
      let code = getCode()
      if (code) {
        try {
          const data = await this.$api.userwechatlogin(code)
          if (!data.userCode) {
            // 未绑定微信和公众号(网页端绑定微信登录或公众号登录都可以，公众号端绑定必须要绑定公众号登录)
            this.wexinSacn = data
            this.activeName = 'second'
            return this.$message('请绑定账户')
          } else {
            // 已绑定微信或者公众号直接登录
            this.seveData(data)
          }
        } catch (error) {
          this.$message.warning('微信认证失败，请重新操作')
        }
      }
    },
    // 切换登录找回密码
    changMode() {
      this.loginForm.username = ''
      this.loginForm.password = ''
      this.loginForm.telephone = ''
      this.loginForm.verification = ''
      this.loginForm.resetpwd = ''
      this.loginForm.checkresetpwd = ''
      this.mode = !this.mode
      this.$refs.loginForm.clearValidate()
    },
    // 登录
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          try {
            // 系统
            this.loading = true
            const data = await this.$api.userlogin(this.loginForm.username, this.loginForm.password)
            if (this.wexinSacn) {
              await this.$api.wechatbind(this.wexinSacn.openid, this.wexinSacn.unionid, this.wexinSacn.nickname, this.wexinSacn.headimgurl)
            }
            await this.seveData(data)
          } catch (error) {
            this.$message.warning(error)
          } finally {
            this.loading = false
          }
        }
      })
    },
    // 保存数据
    async seveData(data) {
      try {
        const tenantlist = await this.$api.tenantlist(data.userCode)
        const tenantinfo = await this.$api.gettenantinfo(data.tenantId)
        const tenanuserlist = await this.$api.getTenanUserList(data.tenantId)
        const tenantuserinfo = await this.$api.gettenantuserinfo(data.tenantId, data.userCode)
        const userinfo = await this.$api.getuserinfo(data.tenantId, data.userCode)
        const branchinfoRes = await this.$api.getbranchinfo(tenantinfo.tenantId)
        let branchlist = branchinfoRes.list.filter((branch) => branch.branchCode != tenantinfo.tenantId) // 过滤自己单位
        const mployeelist = await this.$api.getemployeeList(data.tenantId)
        localStorage.setItem('tenantlist', JSON.stringify(tenantlist))
        localStorage.setItem('tenantId', data.tenantId)
        localStorage.setItem('tenantinfo', JSON.stringify(tenantinfo))
        localStorage.setItem('tenanuserlist', JSON.stringify(tenanuserlist))
        localStorage.setItem('tenantuserinfo', JSON.stringify(tenantuserinfo))
        localStorage.setItem('userinfo', JSON.stringify(userinfo))
        localStorage.setItem('branchlist', JSON.stringify(branchlist))
        localStorage.setItem('mployeelist', JSON.stringify(mployeelist))
        localStorage.setItem('savebranch', branchlist.find((item) => item.branchCode == '85689') ? '85689' : branchlist[0].branchCode)
        localStorage.setItem('timeStamp', new Date().getTime())
        this.$message.success('登录成功')
        location.replace(window.location.origin) // localStorage在当前函数会操作完毕，如果localStorage后再其他函数栈执行操作却为跳转，函数链终端，可能存在后续步骤失效状况，故在当前函数执行跳转
      } catch (error) {
        this.$message.warning(error)
      }
    },
    // 获取验证码
    getVCode() {
      this.$refs.loginForm.validateField('telephone', async (text) => {
        if (!text) {
          try {
            await this.$api.sendSmsCaptcha(this.loginForm.telephone)
            this.counttime = 120
            let timer = setInterval(() => {
              if (!this.counttime) {
                clearInterval(timer)
              } else {
                this.counttime--
              }
            }, 1000)
          } catch (error) {
            this.$message.warning(error)
          } finally {
            this.loading = false
          }
        }
      })
    },
    // 重置密码
    resetPassword() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          try {
            await this.$api.resetpwd(this.loginForm.telephone, this.loginForm.resetpwd, this.loginForm.verification)
            this.mode = true
            this.$message.success('密码重置成功')
          } catch (error) {
            this.$message.warning(error)
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100%;
  width: 100%;
}
.login-container::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin-left: -48%;
  background-image: url('~@/assets/login-bg.svg');
  background-position: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  content: '';
}
.login-left {
  position: absolute;
  left: 25%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: white;
}
.login-com {
  width: 400px;
}
.login-weChatAccount {
  position: absolute;
  left: 90px;
  top: -65px;
  width: 220px;
  height: 220px;
}
.login-right {
  position: absolute;
  right: 30%;
  top: 50%;
  transform: translate(50%, -50%);
}
.login-logo {
  width: 80px;
  height: 80px;
  border-radius: 10px;
  margin: auto auto 50px;
  display: block;
}
.tab-box {
  width: 300px;
  height: 400px;
}
.weixinQr {
  height: 340px;
  overflow: hidden;
}
.js_wx_default_tip {
  text-align: center;
  font-size: 13px;
}
.js_wx_default_tip p {
  margin: 0;
  line-height: 20px;
}
.login-item {
  margin-bottom: 25px;
}
.login-button {
  width: 100%;
}
.forget {
  text-align: right;
}
.verify {
  width: 200px;
}
.sendCode {
  width: 100px;
  padding-left: 0;
  padding-right: 0;
}
.tip {
  font-size: 14px;
  color: grey;
  position: absolute;
  right: 30%;
  top: calc(48% + 250px);
  transform: translate(50%, -50%);
}

.el-input /deep/.el-input-group__prepend,
.el-input /deep/.el-input__inner,
.el-button {
  border-radius: 0;
}
</style>
